/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_bar_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add more than one numeric column. Each column becomes its own series, and the bars for each category are drawn side by side with a legend.`)
};

const es_bar_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Añade más de una columna numérica. Cada columna se convierte en su propia serie, y las barras de cada categoría se dibujan una junto a otra con una leyenda.`)
};

const de_bar_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fügen Sie mehr als eine numerische Spalte hinzu. Jede Spalte wird zu einer eigenen Serie, und die Balken für jede Kategorie werden mit einer Legende nebeneinander gezeichnet.`)
};

const nl_bar_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voeg meer dan één numerieke kolom toe. Elke kolom wordt zijn eigen reeks, en de staven voor elke categorie worden naast elkaar getekend met een legenda.`)
};

const fr_bar_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajoutez plus d'une colonne numérique. Chaque colonne devient sa propre série, et les barres de chaque catégorie sont dessinées côte à côte avec une légende.`)
};

const it_bar_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiungi più di una colonna numerica. Ogni colonna diventa una propria serie, e le barre di ciascuna categoria vengono disegnate fianco a fianco con una legenda.`)
};

const pt_br2_bar_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adicione mais de uma coluna numérica. Cada coluna se torna sua própria série, e as barras de cada categoria são desenhadas lado a lado com uma legenda.`)
};

const pt_bar_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adicione mais do que uma coluna numérica. Cada coluna torna-se a sua própria série, e as barras de cada categoria são desenhadas lado a lado com uma legenda.`)
};

const ja_bar_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`数値列を2つ以上追加してください。各列が独自の系列となり、各カテゴリの棒が凡例とともに横並びに描画されます。`)
};

const zh_bar_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`添加一列以上的数值列。每一列成为独立的系列，每个类别对应的柱子会并排绘制，并附带图例。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const bar_faq_a2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.bar_faq_a2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("bar_faq_a2", locale)
	if (locale === "en") return en_bar_faq_a2(inputs)
	if (locale === "es") return es_bar_faq_a2(inputs)
	if (locale === "de") return de_bar_faq_a2(inputs)
	if (locale === "nl") return nl_bar_faq_a2(inputs)
	if (locale === "fr") return fr_bar_faq_a2(inputs)
	if (locale === "it") return it_bar_faq_a2(inputs)
	if (locale === "pt-BR") return pt_br2_bar_faq_a2(inputs)
	if (locale === "pt") return pt_bar_faq_a2(inputs)
	if (locale === "ja") return ja_bar_faq_a2(inputs)
	return zh_bar_faq_a2(inputs)
};